import React, { useContext, useMemo } from 'react';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import styled from 'styled-components';
import ModuleContext from '../../../CMFW/context/ModuleContext';
import { comparePosition } from '../../../CMFW/grid/comparators/comparePosition';
import { LoadingGrid } from '../../../CMFW/layout/LoadingGrid';
import TextSearch from '../../../components/search/TextSearch';
import { IRefIds } from '../../../constants/refs';
import { useForceRender } from '../../../hooks/useForceRender';
import DialogModel from '../../../models/DialogModel';
import { ILessonOutlineCard, ILessonOutlineCycleActivityDialog } from '../../../types/lessonOutline';
import { IGridData } from '../../../types/models';
import LessonOutlineActivityDialog from '../cards/activities/LessonOutlineActivityDialog';
import { WrapperActivity } from '../cards/LessonOutlineActivity';
import LessonOutlineContext from '../context/LessonOutlineContext';

type IProps = {
  courseId: number;
};

const LessonOutlineSearchDialog: React.FC<IProps> = (props) => {
  const forceRender = useForceRender();
  const dialogModel = useMemo(() => new DialogModel({ render: forceRender, courseId: props.courseId }), [
    forceRender,
    props.courseId,
  ]);
  const lessonOutlineContext = useContext(LessonOutlineContext);

  const gridData = dialogModel.gridData.sort((a, b) => comparePosition(a.position, b.position));

  return (
    <Wrapper>
      <ModuleContext.Provider value={dialogModel}>
        <TextSearch />
        <Droppable
          isDropDisabled={true}
          droppableId={`${IRefIds.dialog}-bank`}
          direction={'vertical'}
          type={ILessonOutlineCard.ACTIVITY}
        >
          {(providedDroppable) => (
            <Wrapper>
              <WrapperResult {...providedDroppable.droppableProps} ref={providedDroppable.innerRef}>
                {gridData.map((dialog: IGridData, index: number) => (
                  <Draggable
                    isDragDisabled={!lessonOutlineContext.DNDEnabled}
                    draggableId={`${IRefIds.dialog}-${dialog.id}`}
                    index={index}
                    key={`${IRefIds.dialog}-${index}`}
                  >
                    {(provided) => (
                      <WrapperActivity
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                        extraWide
                      >
                        <LessonOutlineActivityDialog activity={dialog as ILessonOutlineCycleActivityDialog} />
                      </WrapperActivity>
                    )}
                  </Draggable>
                ))}
                {providedDroppable.placeholder}
              </WrapperResult>
              <LoadingGrid />
            </Wrapper>
          )}
        </Droppable>
      </ModuleContext.Provider>
    </Wrapper>
  );
};

export default LessonOutlineSearchDialog;

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: hidden;
  margin-right: 10px;
  position: relative;
`;

const WrapperResult = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: start;
  overflow-y: auto;
`;
